<template>
  <div class="comp-uploader">
    <el-upload
      key="confirm"
      action="https://api.yourslink.co.uk/common/qupload"
      list-type="picture-card"
      :file-list="fileList"
      :on-preview="onPreview"
      :on-success="onSuccess"
      :on-remove="onRemove"
      :on-change="onChange"
      :before-upload="validateFile"
    >
      <i class="el-icon-plus"></i>
      <!-- <template #file="{ file }">
        <template v-if="_.parseFileType(file, 'video')">
          <div
            v-if="file.url.startsWith('blob:')"
            class="el-upload-list__item-thumbnail c-center-child"
          >
            <i class="el-icon-loading icon-loading"></i>
            <small v-if="inLoading">{{ $t('common.upload-init') }}</small>
            <div v-else>{{ $t('common.upload-progress') }}{{ currentProgress ?? '0%' }}</div>
          </div>
          <video
            v-else
            class="el-upload-list__item-thumbnail"
            :src="file.url.startsWith('https') ? file.url : $config.cdn + file.url"
            style="width: 100%; height: 100%; object-fit: cover"
            controls
          ></video>
        </template>
        <img
          v-else
          class="el-upload-list__item-thumbnail"
          :src="file.url.startsWith('https') ? file.url : $config.cdn + file.url"
          alt=""
        />
      </template> -->
    </el-upload>

    <el-dialog class="dialog" width="60vw" :visible.sync="showPreview">
      <!-- 动态图片无法使用 progressiveImage 组件 -->
      <img class="preview" :src="url" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
export default {
  name: 'comp-uploader',
  components: {
    'el-dialog': Dialog,
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    beforeUpload: {
      type: Function,
      default: () => {},
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onRemove: {
      type: Function,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      showPreview: false,
      url: '',
    };
  },
  methods: {
    validateFile(file) {
      const maxSize = 300 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message({
          type: 'error',
          message: 'File size exceeds 300MB',
        });
        return false;
      }
      return this.beforeUpload(file);
    },
    onPreview(file) {
      console.log(`file => `, file);
      this.url = file.response ? file.response.data.cdn + file.response.data.url : file.url;
      this.showPreview = true;
      this.$emit('onPreview', file);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  gap: 1rem;
}
.log-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.file-name {
  grid-column: 1/-1;
}
.log {
  text-align: left;
}

video {
  width: 100vw;
  max-height: 40vh;
}
input[type='file'] {
  margin: auto;
  padding: 2rem;
}
button {
  padding: 16px 0;
  flex: 1;
}

.icon-loading {
  font-size: 2rem;
  color: lightgray;
}

.dialog {
}
.preview {
  display: block;
  margin: auto;
  width: 100%;
  height: 50vh;
  max-width: 600px;
  max-height: 600px;
  object-fit: contain;
}
</style>
